import React, { useState, useRef } from "react";
import html2pdf from "html2pdf.js";
import { blogs } from "./Blog";
import "./blog.css";
import { Download, Maximize, Share2 } from "lucide-react";


const BlogPage = () => {
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [fullImage, setFullImage] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const blogRef = useRef(null);

  // PDF Download
  const handleDownloadPDF = (e, blog) => {
    e.stopPropagation();

    const element = document.createElement("div");
    element.innerHTML = `
    <div style="padding:40px;font-family:sans-serif">
      <h1>${blog.title}</h1>
      <p style="color:#555;font-size:14px;margin-bottom:10px">
        ${blog.date} • ${blog.author}
      </p>
      <img src="${blog.image}" style="width:100%;margin:20px 0;border-radius:12px" />
      <div>${blog.content}</div>
    </div>
  `;

    html2pdf()
      .from(element)
      .set({
        margin: 10,
        filename: `${blog.title.replace(/\s+/g, "-").toLowerCase()}.pdf`,
        html2canvas: { scale: 2 },
        jsPDF: { format: "a4" },
      })
      .save();
  };


  // Fullscreen Blog
  const openBlogFullscreen = (blog) => {
    setSelectedBlog(blog);
    setTimeout(() => blogRef.current?.requestFullscreen(), 100);
  };

  // Fullscreen Image
  const openImageFullscreen = (img) => {
    setFullImage(img);
    setTimeout(() => {
      document.getElementById("image-fullscreen")?.requestFullscreen();
    }, 100);
  };

  // SEARCH FILTER
  const filteredBlogs = blogs.filter((blog) => {
    const q = searchQuery.toLowerCase();
    return (
      blog.title.toLowerCase().includes(q) ||
      blog.content.toLowerCase().includes(q)
    );
  });
  const handleShare = (e, blog) => {
    e.stopPropagation();

    if (navigator.share) {
      navigator.share({
        title: blog.title,
        text: blog.title,
        url: window.location.href,
      });
    } else {
      alert("Sharing is not supported on this browser");
    }
  };

  const highlightText = (text, query) => {
    if (!query) return text;

    const regex = new RegExp(`(${query})`, "gi");
    return text.replace(regex, `<mark class="highlight">$1</mark>`);
  };

  return (
    <div className="container ">
      <h1 className="page-title page-content">Explore Our Latest Blogs</h1>

      {/* SEARCH BAR */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search blogs by keyword..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      {/* BLOG GRID */}
      <div className="blog-grid">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map((blog) => (
            <div className="blog-card" key={blog.id}>

              <div className="image-container">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="card-image"
                  onClick={() => openImageFullscreen(blog.image)}
                />

                {/* BUTTON GROUP */}
                <div className="icon-group top-left">
                  <button
                    className="icon-btn"
                    onClick={(e) => handleShare(e, blog)}
                    title="Share"
                  >
                    <Share2 size={18} />
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => openBlogFullscreen(blog)}
                    title="View Full Screen"
                  >
                    <Maximize size={18} />
                  </button>

                  <button
                    className="icon-btn"
                    onClick={(e) => handleDownloadPDF(e, blog)}
                    title="Download PDF"
                  >
                    <Download size={18} />
                  </button>
                </div>
              </div>

              <div className="card-body mt-2">
                <h3
                  dangerouslySetInnerHTML={{
                    __html: highlightText(blog.title, searchQuery),
                  }}
                />


                <p className="blog-meta">
                  <h3>{blog.author} | {blog.date}  </h3>
                </p>

                <div
                  className="blog-content"
                  dangerouslySetInnerHTML={{
                    __html: highlightText(blog.content, searchQuery),
                  }}
                />

              </div>

            </div>
          ))
        ) : (
          <p className="no-results">No blogs found matching your search.</p>
        )}
      </div>

      {/* BLOG FULLSCREEN */}
      {selectedBlog && (
        <div className="fullscreen-blog" ref={blogRef}>
          <button className="close-btn" onClick={() => setSelectedBlog(null)}>
            ×
          </button>

          <h1>{selectedBlog.title}</h1>
          <p className="blog-meta fullscreen-meta">
            <span>{selectedBlog.date}</span> • <span>{selectedBlog.author}</span>
          </p>
          <img
            src={selectedBlog.image}
            alt="header"
            className="fullscreen-image"
            onClick={() => openImageFullscreen(selectedBlog.image)}
          />

          <div className="fullscreen-content">{selectedBlog.content}</div>

          <button
            className="download-btn-large"
            onClick={(e) => handleDownloadPDF(e, selectedBlog)}
          >
            Download PDF
          </button>
        </div>
      )}

      {/* IMAGE FULLSCREEN */}
      {fullImage && (
        <div id="image-fullscreen" className="image-fullscreen">
          <button className="close-btn" onClick={() => setFullImage(null)}>
            ×
          </button>
          <img src={fullImage} alt="fullscreen" />
        </div>
      )}
    </div>
  );
};

export default BlogPage;
